import { useState } from 'react';
import { MetricsForm } from '../types';

type UseMetricsForm = {
  form: MetricsForm;
  setForm: (form: MetricsForm) => void;
  onSave: () => void;
  onUpdate: () => void;
  onCancel: () => void;
};

type UseMetricsFormOptions = {
  initialValues?: Partial<MetricsForm>;
};

export const useMetricsForm = (
  options?: UseMetricsFormOptions
): UseMetricsForm => {
  const [form, setForm] = useState<MetricsForm>({
    name: '',
    description: '',
    type: 'Sensitivity',
    definition: '',
    parameters: [],
    ...options?.initialValues,
  });

  return {
    form,
    setForm,
    onSave: () => {},
    onUpdate: () => {},
    onCancel: () => {},
  };
};
